import React from 'react';
import { Card } from "react-bootstrap";
import face_balazs_varga from "../../assets/img/face_balazs_varga.jpg";
import ShowMoreText from "react-show-more-text";
import proj_drive_cycle from "../../assets/img/proj_drive_cycle.png";

const Balazs_Varga_drive_cycle = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_drive_cycle} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_balazs_varga}
              /* ez a szöveg lesz majd a banneren */
              alt="Synthetic drive-cycle generation from GPS data"
            />{" "}
            <p className="text7">Balázs Varga</p>
            <br />
            <p className="text8">
              Research Fellow{" "}
            </p>
            <p className="text8">BME Traffic Lab </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Vehicle driver models try to mimic the behaviour of real drivers. Their main use is to generate 
            realistic inputs (steering, braking, desired speed, etc.) to the vehicle (sub-)model in vehicle 
            dynamics simulations. 
            <br/>
            The task is to create a generative algorithm that can generate realistic drive-cycles (speed 
            profiles) for given road conditions. The following data is available for the task: a set of GPS 
            trajectories from the same route and some route-specific data such as speed limit and 
            congestion level. The task involves the pre-processing of the GPS logs too.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Balazs_Varga_drive_cycle;